// @flow

import ContactPage from 'app/developer-v3/pages/contact';

export default {
  isAuthRequired: false,
  routes: {
    '.': ContactPage,
  },
};
